import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Container from "react-bootstrap/Container";

import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Admin from "./pages/Admin";
import Settings from "./pages/Settings";
import Reports from "./pages/Reports";
import Import from "./pages/Import";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

import { DatabaseProvider } from "./contexts/DatabaseContext";
import { UserProvider } from "./contexts/UserContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { OrderProvider } from "./contexts/OrderContext";
import { PaneProvider } from "./contexts/PaneContext";
import { PatronProvider } from "./contexts/PatronContext";
import { SnackbarProvider } from "notistack";

const App = () => {
  return (
    <>
      <SnackbarProvider maxSnack={3}>
        <BrowserRouter>
          <DatabaseProvider>
            <UserProvider>
              <ThemeProvider>
                <PaneProvider>
                  <PatronProvider>
                    <OrderProvider>
                      <Container fluid className="App">
                        <Routes>
                          <Route path="/dashboard" element={<Dashboard />} />;
                          <Route path="/login" element={<Login />} />;
                          <Route path="/admin" element={<Admin />} />;
                          <Route path="/settings" element={<Settings />} />;
                          <Route path="/reports" element={<Reports />} />;
                          <Route path="/import" element={<Import />} />;
                          <Route path="/forgot" element={<ForgotPassword />} />
                          ;
                          <Route
                            path="/reset/:data"
                            element={<ResetPassword />}
                          />
                          ;
                          <Route
                            path="/*"
                            element={<Navigate to="/login" replace />}
                          />
                        </Routes>
                      </Container>
                    </OrderProvider>
                  </PatronProvider>
                </PaneProvider>
              </ThemeProvider>
            </UserProvider>
          </DatabaseProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </>
  );
};

export default App;
